import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectionChangedEvent } from 'ag-grid-enterprise';
import { Observable, defer, forkJoin } from 'rxjs';
import { CompanyVendor, SiteVendor } from 'src/app/classes/models';
import { SiteService } from 'src/app/services/site.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-assign-vendors-to-site-modal',
  templateUrl: './assign-vendors-to-site-modal.component.html',
  styleUrls: ['./assign-vendors-to-site-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AssignVendorsToSiteModalComponent implements OnInit {
  @Input() SiteId?: number;
  SiteVendors: SiteVendor[] = [];

  suppliedGridQueryData: { [key: string]: any } = {};

  disableAssignVendorBtn: boolean = false;

  constructor(
    private ToastService: ToastService,
    private SiteService: SiteService,
    private activeModal: NgbActiveModal
  ) {}

  close(result?: any) {
    this.activeModal.close(result);
  }

  addVendorsToSite() {
    if (this.SiteVendors && this.SiteVendors.length === 0) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No vendors selected to assign.'
      );
    }

    this.disableAssignVendorBtn = true;

    forkJoin(
      this.SiteVendors.map((siteVendor) =>
        this.SiteService.saveSiteVendor(siteVendor)
      )
    ).subscribe({
      next: (SiteVendors: SiteVendor[]) => {
        if (SiteVendors) {
          this.ToastService.addSuccessToast(
            'Success',
            'Successfully created Site Vendors.'
          );
          this.close();
        }
      },
      error: (err) => {
        this.disableAssignVendorBtn = false;
        throw this.ToastService.addErrorToast('Error', err.message, {
          returnError: true
        });
      }
    });
  }

  onSelectionChange(event: SelectionChangedEvent) {
    const { api } = event;
    this.SiteVendors = [];

    if (api) {
      const companyVendors: CompanyVendor[] = api.getSelectedRows();
      companyVendors.forEach((cv) => {
        const { ExemptVendorId, ClientRegisteredVendorId, VendorId } = cv;

        this.SiteVendors.push({
          SiteId: this.SiteId,
          ExemptVendorId,
          ClientRegisteredVendorId,
          VendorId
        });
      });
    }
  }

  ngOnInit(): void {
    if (!this.SiteId) {
      throw this.ToastService.addErrorToast('Error', 'No Site ID found.', {
        returnError: true
      });
    }

    this.SiteService.getSiteVendors({ SiteId: this.SiteId }).subscribe({
      next: (SiteVendors: SiteVendor[]) => {
        if (SiteVendors && SiteVendors.length > 0) {
          const siteClientRegisteredVendorIds = SiteVendors.map(
            (siteVendor) => siteVendor.ClientRegisteredVendorId
          ).filter((id) => id !== null);
          const siteVendorIds = SiteVendors.map(
            (siteVendor) => siteVendor.VendorId
          ).filter((id) => id !== null);
          const siteExemptVendorIds = SiteVendors.map(
            (siteVendor) => siteVendor.ExemptVendorId
          ).filter((id) => id !== null);

          const vendorQuery = {
            options: { required: false },
            attributes: ['id', 'legalName']
          };

          if (
            siteClientRegisteredVendorIds &&
            siteClientRegisteredVendorIds.length > 0
          ) {
            Object.assign(this.suppliedGridQueryData, {
              ClientRegisteredVendorId: {
                $or: [{ $notIn: siteClientRegisteredVendorIds }, null]
              }
            });
          }

          if (siteVendorIds && siteVendorIds.length > 0) {
            Object.assign(this.suppliedGridQueryData, {
              VendorId: {
                $or: [{ $notIn: siteVendorIds }, null]
              }
            });
          }

          if (siteExemptVendorIds && siteExemptVendorIds.length > 0) {
            Object.assign(this.suppliedGridQueryData, {
              ExemptVendorId: {
                $or: [{ $notIn: siteExemptVendorIds }, null]
              }
            });
          }

          Object.assign(this.suppliedGridQueryData, {
            Vendor: JSON.stringify(vendorQuery),
            ExemptVendor: JSON.stringify(vendorQuery),
            ClientRegisteredVendor: JSON.stringify(vendorQuery)
          });
        }
      }
    });
  }
}
